// import { useMutation } from "@apollo/client"
import { useQuery } from "@apollo/client"
import DescriptionDetail from "src/shared/components/data-display/description-detail/DescriptionDetail"
import Drawer from "src/shared/components/layout/drawer/Drawer"
import { OBTENER_TICKET } from "../graphql/ticket"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { useDate } from "src/shared/hooks/useDate"
import { getName } from "src/pages/propinas/home/helpers/name"
import { useFormatDate } from "src/shared/hooks/useFormatDate"

export function CancellationDetails({
    onClose,
    isOpen,
    ticketId,
    movimiento
}: {
    onClose: () => void
    isOpen: boolean
    ticketId: string
    movimiento: any
}): JSX.Element {
    const { data: data } = useQuery(OBTENER_TICKET, {
        variables: {
            ticket_id: ticketId,
        },
    })
    const { formatCustomDate } = useFormatDate()
    const { UTCStringToLocalDate } = useDate()

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton={true} onClose={onClose}>
            <div>
                <div className="detalle-h-view__head" style={{ marginTop: 24 }}>
                    <p className="detalle-h-view__title">Cancelación</p>
                    <p className="detalle-h-view__subtitle">{data?.ticket?.folio || "-"}</p>
                </div>
            </div>
            <div>
                <div
                    className="reservas-screen__drawer__description"
                    style={{
                        height: "calc(100dvh - 160px)",
                    }}
                >
                    <DescriptionDetail
                        icon={"dollarCircle"}
                        label={"Monto"}
                        value={formatCurrency(movimiento?.total_movimiento || 0)}
                    />
                    <DescriptionDetail
                        icon={"creditCard"}
                        label={"Método de pago"}
                        value={movimiento?.metodo_pago || "-"}
                    />
                    <DescriptionDetail icon={"FolderFill"} label={"Categoría"} value={movimiento?.categoria?.split(" / ")?.[1] || "-"} />
                    <DescriptionDetail
                        icon={"Document"}
                        label={"Concepto de cancelación"}
                        value={data?.ticket ? data?.ticket?.motivo_cancelacion : "-"}
                    />
                    <DescriptionDetail
                        icon={"calendarChecked"}
                        label="Fecha y hora de venta"
                        value={
                            data?.ticket?.fecha_impresion
                                ? formatCustomDate(UTCStringToLocalDate(data?.ticket?.fecha_impresion), "DD/MMM/YY hh:mm a")
                                : "-"
                        }
                    />
                    <DescriptionDetail
                        icon={"calendarFill"}
                        label="Fecha y hora de cancelación"
                        value={
                            data?.ticket?.fecha_cancelacion
                                ? formatCustomDate(UTCStringToLocalDate(data?.ticket?.fecha_cancelacion), "DD/MMM/YY hh:mm a")
                                : "-"
                        }
                    />
                    <DescriptionDetail
                        icon={"userFilled"}
                        label={"Responsable"}
                        value={data?.ticket?.usuario ? getName(data?.ticket?.usuario) : "-"}
                    />
                </div>
            </div>
        </Drawer>
    )
}